import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { styled } from "@mui/material/styles";

import Button from "../button/Button";

const StyledDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiPaper-root": {
    [theme.breakpoints.down("md")]: {
      width: "100%",
      marginLeft: 36,
    },
    [theme.breakpoints.up("md")]: {
      width: "calc(100% - 80px)",
      marginLeft: 80,
      marginRight: 0,
    },
  },
}));

function DialogModal({
  children,
  title,
  submitText,
  onSubmit,
  submitting,
  cancelText,
  onClose,
  hideCancelButton,
}) {
  return (
    <StyledDialog open={true} fullWidth onClose={onClose}>
      <DialogTitle id="create-task-dialog-title">{title}</DialogTitle>
      <DialogContent>{children}</DialogContent>
      <DialogActions>
        {onClose && !hideCancelButton && (
          <Button
            title={cancelText || "Cancel"}
            onClick={onClose}
            style={{ backgroundColor: "rgb(243, 243, 243)", color: "#222" }}
          />
        )}
        {onSubmit && (
          <Button
            title={submitText}
            onClick={onSubmit}
            submitting={submitting}
          />
        )}
      </DialogActions>
    </StyledDialog>
  );
}

export default DialogModal;
